import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { SubscriptionDatePipe } from "../../../helpers/subscription-datepipe/subscription-datepipe";
import { LoaderComponent } from "../../common/loader/loader";
import { TerminatedCardComponent } from "../terminated-card/terminated-card";

@Component({
  selector: "shortcut-menu",
  templateUrl: "shortcut-menu.html",
  styleUrls: ["shortcut-menu.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, LoaderComponent, SubscriptionDatePipe, TerminatedCardComponent],
})
export class ShortcutMenu {
  protected subscription = input.required<{ status: string; endDate?: number | null }>();

  protected isTerminated = computed(() => this.subscription().status === "terminated");
  protected endDate = computed(() => this.subscription().endDate);
}
